import React, { Component } from "react";
import { connect } from "react-redux";
import InferenceOff from "./Inference/InferenceOff";
import InferenceOn from "./Inference/InferenceOn";

class MainInference extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let Inference;
    if (this.props.trainingStatus) {
      Inference = <InferenceOn deviceType={this.props.deviceType} obj={this.props.obj}/>;
    } else {
      Inference = <InferenceOff />;
    }
    return <div>{Inference}</div>;
  }
}

const mapStateToProps = state => {
  return {
    trainingStatus: state.trainingStatus
  };
};

export default connect(mapStateToProps)(MainInference);
